export default "__VITE_ASSET__1$$nKFow__"